// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InformationDiv } from './InformationStyles';
import {
  type Partner,
  type ReferralDetails,
  type Currency
} from '../../../utilities/types';

import { toggleEdit, showTooltip } from './reducer';
import PartnerInfoBlock from './PartnerInfoBlock';
import BasicInfoForm from './BasicInfoForm';
import BasicInfoBlock from './BasicInfoBlock';
import ContractInfoBlock from './ContractInfoBlock';
import { getPartnerCurrency } from '../../../utilities/selectors';

type Props = {
  partner: Partner,
  editing: boolean,
  toggleEdit: () => void,
  referralDetails: ReferralDetails,
  partnerCurrency: Currency,
  activeTooltip: ?string,
  showTooltip: (tooltip: string) => void
};

class AccountInformation extends Component<Props> {
  render() {
    return (
      <InformationDiv>
        {this.props.editing ? (
          <BasicInfoForm toggleEdit={this.props.toggleEdit} />
        ) : (
          <BasicInfoBlock
            partner={this.props.partner}
            toggleEdit={this.props.toggleEdit}
          />
        )}
        <ContractInfoBlock
          referralDetails={this.props.referralDetails}
          partnerCurrency={this.props.partnerCurrency}
          showTooltip={this.props.showTooltip}
          activeTooltip={this.props.activeTooltip}
        />
        <PartnerInfoBlock
          referralDetails={this.props.referralDetails}
          partnerCurrency={this.props.partnerCurrency}
          showTooltip={this.props.showTooltip}
          activeTooltip={this.props.activeTooltip}
        />
      </InformationDiv>
    );
  }
}

const mapStateToProps = state => ({
  partner: state.global.partner,
  referralDetails: state.global.referralDetails,
  editing: state.account.info.editing,
  partnerCurrency: getPartnerCurrency(state),
  activeTooltip: state.account.info.activeTooltip
});

const mapDispatchToProps = {
  toggleEdit,
  showTooltip
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountInformation);
